module.exports = __webpack_public_path__ + "img/titleAtive1.baba075.webp";